import React, {useState} from 'react';
import styles from "./image.module.scss";
import {PageSpinner} from "../../../../com/pagesTab/pagesSpinner/spinner";
// import {ReactComponent as ImageWithError} from "../../../../../assets/editors/image_with_error.svg";
import {PagesDataStateDto} from "../../pages";
import {FlyerPageDto} from "../../../../../dtos";

interface Props {
    src: string,
    pagesDataState: PagesDataStateDto
    setPagesDataState: (e: any) => void,
    dataKey: FlyerPageDto | any
}

export const AsyncPageImage = (props: Props) => {
    const [didLoad, onLoad] = useState(false);
    const [notLoad, onNotLoad] = useState(false);

    React.useEffect(() => {
        onLoad(false);
        if (props.src) {
            const handleLoad = () => {
                onLoad(true);
                // const newArr = props.pagesDataState.notLoaderPagesImagesCodes.filter((key:any) => {
                //     if (props.dataKey.flpRecId !== key) {
                //         return key;
                //     }
                // })
                // props.setPagesDataState({
                //     ...props.pagesDataState,
                //     notLoaderPagesImagesCodes: newArr
                // });

                onNotLoad(false);
            };
            const handleError = () => {
                // if (!props.pagesDataState.notLoaderPagesImagesCodes.includes(props.dataKey!.flpRecId!)) {
                //     props.setPagesDataState({
                //             ...props.pagesDataState,
                //             notLoaderPagesImagesCodes: [...props.pagesDataState.notLoaderPagesImagesCodes, props.dataKey.flpRecId]
                //         }
                //     )
                // }

                onNotLoad(true);
            };
            const image = new Image();
            image.addEventListener('load', handleLoad);
            image.addEventListener('error', handleError);
            image.src = props.src;
            return () => {
                image.removeEventListener('load', handleLoad);
                image.removeEventListener('error', handleError);
            };
        }
    }, [props.src]);
    return (<>
        <img className={didLoad && !notLoad ? '' : styles.hide_image}
             src={props.src}
             alt={`don't upload`}
        />
        {
            !didLoad && !notLoad && <PageSpinner/>
        }
        {notLoad && <></>}
    </>)

};
